let collapseTitle = document.querySelectorAll('.footer-wrapper__nav-title');

for (let i = 0; i < collapseTitle.length; i++) {
  collapseTitle[i].addEventListener('click', () => {
    collapseTitle[i].classList.toggle('active');
    console.log(i);
  })
}